//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  props: {
    item: {
      type: String,
      default: '1'
    },
    img: {
      type: String,
      default: null
    }
  }
}
